export default {
    messageTitle: 'Message Center',
    messageCenterClose: 'Message Center closed, unable to receive push notifications',
    openNotification: 'Enable',
    noData: 'No messages',
    loadingFailed: 'Failed to load',
    systemNotion: 'System Notice',
    businessNotion: 'Business Reminder',
    activityNotion: 'Activity Reminder',
    serviceNotion: 'Online Service',
    toServeYou: 'Happy to serve you',
    viewDetails: 'View Details',
    productName: 'Product:',
    amount: 'Order Amount:',
    filledAmount: 'Confirmed Amount:',
    parValue: 'Face Value:',
    filledQuantity: 'Confirmed Shares:',
    filledPrice: 'Transaction Price:',
    confirmedPrice: 'Confirmed Price:',
    accruedInterest: 'Accrued Interest:',
    informationTitle: 'Fosun Wealth Daily',
}
